export default {
  carvana: {
    black: '#000',
    lightRed: '#e63131',
    blue: '#00aed9',
    blueTwo: '#018DC0',
    blueThree: '#007BC7',
    darkBlue: '#0094ca',
    darkBlue2: '#004891',
    darkBlue3: '#024F6C',
    darkBlue4: '#183558',
    darkBlue5: '#00619E',
    lightestBlue: '#CFEAF2',
    green: '#168C10',
    lightGreen: '#6a9c00',
    lightYellow: '#fbebc7',
    white: '#ffffff',
    whiteTwo: '#f1f0f0',
    orange: '#feb948',
    orangeTwo: '#fcbc4d',
    darkOrange: '#f1a426',
    red: '#d45756',
    errorRed: '#ffedee',
    heartRed: '#ff7171',
    dark: '#5c5c5c',
    grayOne: '#e1e1e1',
    grayTwo: '#d0d0d0',
    grayThree: '#999999',
    grayFour: '#696969',
    grayFive: '#EBEBEB',
    graySix: '#363636',
    graySeven: '#c7c7c7',
    grayEight: '#555555',
    grayNine: '#c4c4c4',
    grayTen: '#777777',
    grayEleven: '#333333',
    grayTwelve: '#F9F9F9',
    grayThirteen: '#F6F6F6',
    grayFourteen: '#F0F0F0',
    grayFifteen: '#CCCCCC',
    grayBackground: '#F3F3F3',
    blackOne: '#979797',
    greenTwo: '#7ac243',
    orangeThree: '#f39700',
    graySixteen: '#d8d8d8',
    graySeventeen: '#262626',
    grayEighteen: '#757989',
    grayNineteen: '#AAB1C7',
    redTwo: '#c6000e',
    darkRed: '#FF7171',
    greenThree: '#1DD08B',
    lightBlue: '#F4F8FA',
    lightGray: '#D9DDE9',
    blueZodiac: '#122946'
  },
  breakpoints: {
    xs: 480,
    sm: 768,
    md: 1074,
    lg: 1400,
    xl: 1920
  }
};
